import TwoPartsInfoBoxesSection from 'components/two-parts-info-boxes-section'
import { accessManagementData } from 'content/home-page'
import React from 'react'

export default function AccessManagement() {
  return (
    <TwoPartsInfoBoxesSection
      data={accessManagementData}
      sectionBgColor="var(--blue-5)"
      showSeparator={false}
    />
  )
}
